module.exports = __webpack_public_path__ + "static/media/s_pink_1.82b1ec2d.mp3";